import { shadowLevel3 } from '../../shadows';

export const classes = {
  paper: {
    borderRadius: 4,
    boxShadow: `${shadowLevel3} !important`,
    boxSizing: 'content-box',
  },
};
